import React from 'react';
import ZUtil from './zutil';
import ZProps from './zprops';
import { ROUTER } from "./AMCRouter";
import ZNetwork from "./znetwork";
import { APP } from "./App";
import { AUTH } from './AMCAuth';
import AMC from "./AMC";
import PleaseStandBy from "./PleaseStandBy";
import { AutomaticAddOrganizationPopup } from "./AMCAuth";
import { AutomaticOrganizationSigninPopup } from "./AMCAuth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'


export default class AMCOrganizationPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { view: "orgs" };
	}
	componentDidMount() {
		let org_uri = ZProps.get("path").split("/")[2];
		if (org_uri) {
			if (org_uri !== ZProps.get("user").uri && org_uri !== ZProps.get("user").group) {
				return APP.showPopup(<AutomaticOrganizationSigninPopup org_uri={org_uri} />);
			}
			ZNetwork.get("organization", "members", (err, members) => {
				if (!err) {
					this.setState({ view: "org", org_uri: org_uri, members: members });
				} else {
					this.setState({ error: err });
				}
			});
		} else {
			ZNetwork.get("organizations", (err, orgs) => {
				if (!err) {
					this.setState({ orgs: orgs });
				} else {
					this.setState({ error: err });
				}
			});
		}
	}
	addOrganization = (e) => {
		APP.showPopup(<AutomaticAddOrganizationPopup />);
	}
/*
		let uri = e.target.value.trim().replace(/\s+/g, "");
		if (uri.length === 0) {
			return this.setState({ errors: "Name is invalid" });
		}
		let user = ZProps.get("user");
		let password = Document.getElementById("aorganization_password_id").value.trim();
		if (password.length === 0) {
			return this.setState({ errors: "Password is invalid" });
		}
		ZNetwork.post("organization", { org_username: uri, org_password: "change me", email: user.email }, (err) => {
			this.forceUpdate();
		});
	}
	onNewOrganizationKeyDown = (e) => {
		if (e.key === 'Enter') {
			this.addOrganization(e);
		}
	}
*/
	switchToOrg = (uri) => {
		ZNetwork.post("organization", "switch", { org_uri: uri }, (err, data) => {
			if (!err) {
				AUTH.signedIn(data.user, ZProps.get("usersettings"), data.group);
			}
			this.forceUpdate();
		});
	}
	viewOrg = (org) => {
		ROUTER.pushRoute("/organizations/" + org);
	}
	addMember = (uri) => {
		if (uri.length > 0) {
			ZNetwork.post("organization", "member", { member_uri: uri }, (err) => {
				this.componentDidMount();
			});
		}
	}
	onNewMemberKeyDown = (e) => {
		let uri = e.target.value.trim();
		if (e.key === 'Enter') {
			this.addMember(uri);
		}
	}
	removeMember = (m) => {
		APP.areYouSure(() => {
			ZNetwork.post("organization", "removemember", { member_uri: m.uri }, (err) => {
				if (!err) {
					this.componentDidMount();
				}
			});
		});
	}
	render() {
		let { orgs, members, org_uri, view, errors } = this.state;
		if (!orgs && !members) {
			return <PleaseStandBy />;
		}
		let payload = "";
		let user = ZProps.get("user");
//						<div>Add new organization <input type="text" placeholder="Name"  onKeyDown={e => this.onNewOrganizationKeyDown(e)} /> <input type="text" placeholder="Password" id="aorganization_password_id" /> <button className="AMCButton" onClick={this.addOrganization}>Add</button></div>
//						<div><button className="AMCButton" onClick={this.addOrganization}>Add new organization</button></div>
		switch (view) {
			case "orgs" :
				payload = 
					<div className="AMCOrgMyOrganizations">
						<h1>Organizations</h1>
						<h5>Organizations you belong to</h5>
						<div>{errors}</div>
						<ul>
							<li key={"personal"}><span className="AMCOrgListName">Personal</span> <span className="AMCOrgSwitchOption">{user.group === user.uri ? <FontAwesomeIcon icon={faCheck} /> : <button className="AMCButton" title="switch to personal account" onClick={e => this.switchToOrg(user.uri)}>switch</button>}</span> </li>
							{ orgs.map( org => <li key={org} onClick={e => this.viewOrg(org)}><span className="AMCOrgListName">{org}</span> <span className="AMCOrgSwitchOption">{user.group === org ? <FontAwesomeIcon icon={faCheck} /> : <button className="AMCButton" title="switch to this organization" onClick={e => this.switchToOrg(org)}>switch</button>}</span></li> ) }
						</ul>
					</div>
				break;
			case "org" :
				payload = 
					<div>
						<div className="AMCOrgHeader">
							{ user.uri === org_uri ?
								<div>
								<div className="AMCOrgHeaderThumb"><a href="/account" onClick={e => { return ROUTER.pushRoute("/account") }}>{AMC.getUserOrGroupThumbElement(org_uri)}</a></div>
								<div className="AMCOrgHeaderTitle"><a href="/account" onClick={e => { return ROUTER.pushRoute("/account") }}>{org_uri}</a></div>
								<div className="AMCOrgAddMemberButton">
									<input type="text" id="amc_org_add_memeber_textfield" placeholder="member's username" onKeyDown={e => this.onNewMemberKeyDown(e)} />
									<button className="AMCButton" onClick={e => this.addMember(document.getElementById("amc_org_add_memeber_textfield").value)}>Add member</button> 
								</div>
								</div>
							: 
								<div>
								<div className="AMCOrgHeaderThumb">{AMC.getUserOrGroupThumbElement(org_uri)}</div>
								<div className="AMCOrgHeaderTitle">{org_uri}</div>
								</div>
							}
						</div>
						<div className="AMCOrgList">
						<ul>
							{ members.map( m => <li key={m.uri} onClick={e => ROUTER.pushRoute("/" + m.uri)}>
								<span className="AMCOrgListName">{m.name}</span> 
								{ user.uri === org_uri ? <span className="AMCOrgListRemove" onClick={e => { ZUtil.eatEvent(e); this.removeMember(m); }}>remove</span> : '' }
								</li> ) }
						</ul>
						</div>
					</div>
				break;
			default:
				payload = "Unknown view: " + view;
				break;
		}
		return (
			<div className="AMCOrganization">
				{payload}
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/AMCOrganizationPage.js